import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./index.css";

// 🔴 THE ROUTER IS HERE, NOT INSIDE `App`, so `App` can be rendered under a `MemoryRouter` in
// a test. `main.py`'s SPA fallback already serves index.html for every non-`/api` path, so a
// deep link into a grade survives a reload and the back button works.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
